import { CompositeMeterData } from '@models/meter-scans/composite/composite-meter-data';

export class QOTData extends CompositeMeterData {
  username: string; // Here for model uniformity. necessary for referenceSweep.
  timestamp: number;
  frequencyMHz: number; // 489
  latitude: number; // 39.750090753696625
  longitude: number; // -105.00337969521526
  merTimeLine: (MerTimeLineEntity)[];
  postErrorTimeLine: (PostErrorTimeLineEntityOrPreErrorTimeLineEntity)[];
  preErrorTimeLine: (PostErrorTimeLineEntityOrPreErrorTimeLineEntity)[];

  constructor(
    httpResponse: any
  ) {
    super();
    this.username = httpResponse.userId; // The backend changes from username to userId a lot. We don't stand for that sort of funny business on the front end.
    this.timestamp = httpResponse.timestamp;
    this.frequencyMHz = httpResponse.frequencyMHz;
    this.latitude = httpResponse.latitude;
    this.longitude = httpResponse.longitude;
    this.merTimeLine = httpResponse.merTimeLine;
    this.postErrorTimeLine = httpResponse.postErrorTimeLine;
    this.preErrorTimeLine = httpResponse.preErrorTimeLine;
  }
}

export interface MerTimeLineEntity {
  ts: number;
  mer: number;
}
export interface PostErrorTimeLineEntityOrPreErrorTimeLineEntity {
  ts: number;
  errors: number;
}
